// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";

// import { Outlet, useNavigate } from "react-router-dom";
// import {
//   getUserById,
//   selectToken,
//   selectUser,
// } from "../../redux/users/usersSlice";

// function UsersLayout() {
//   const token = useSelector(selectToken);
//   const user = useSelector(selectUser);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (!token) {
//       navigate("/users/sign-in");
//     }
//   }, [token]);

//    useEffect(() => {
//      if (token && !user) {
//        dispatch(getUserById());
//      }

//      if (token && user?.role === "employee") {
//        console.log("Navigating to employee");
//        navigate("/users/employee");
//      } else if (token && user?.role === "supervisor") {
//        navigate("/users/supervisor");
//      }
//    }, [token, user, navigate, dispatch]);

//   return (
//     <div className="">
//       <div className="">
//         <Outlet />
//       </div>
//     </div>
//   );
// }

// export default UsersLayout;
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import {
  getUserById,
  selectToken,
  selectUser,
} from "../../redux/users/usersSlice";

function UsersLayout() {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) {
      // Redirect to sign-in if there is no token
      navigate("/users/sign-in");
    } else {
      // If token exists and user is not loaded, fetch user details
      if (!user) {
        dispatch(getUserById());
      } else {
        // Navigate based on the user role only if the user is loaded
        if (user.role === "employee") {
          navigate("/users/employee");
        } else if (user.role === "supervisor") {
          navigate("/users/supervisor");
        }
      }
    }
  }, [token, user, navigate, dispatch]);

  return (
    <div className="">
      <div className="">
        <Outlet />
      </div>
    </div>
  );
}

export default UsersLayout;
